import "./Hero.css";

import VideoBg from "../../assets/videos/bg-world.mp4"

function Hero() {
    return (
        <section className="hero">

            <video
                className="hero-video"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src={VideoBg} type="video/mp4" />
            </video>

            <div className="hero-overlay">

                <div className="hero-content">

                    <h1>
                        VISIÓN CREATIVA,
                        <br />
                        TECNOLOGÍAS Y
                        <br />
                        EXPERIENCIA DIGITAL
                    </h1>

                </div>

            </div>

        </section>
    );
}

export default Hero;
